import { ImpersonationSelection } from "./types";

export function isSameOriginAccount(
  selection: ImpersonationSelection | null,
  origin: ImpersonationSelection | null,
): boolean {
  return (
    selection?.tenant?.id === origin?.tenant?.id &&
    selection?.account?.id === origin?.account?.id
  );
}

export function isSameAccountSelection(
  left: ImpersonationSelection | null,
  right: ImpersonationSelection | null,
): boolean {
  return (
    (left?.tenant?.id ?? null) === (right?.tenant?.id ?? null) &&
    (left?.account?.id ?? null) === (right?.account?.id ?? null)
  );
}